import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { apiClient } from '../../../helpers/api_helper';
import { Spinner } from "reactstrap";


interface ChartData{
  series: number[],
  labels: string[],
  colors: string[],
}

const Donut = () => {
  const [chartData, setChartData] = useState<ChartData | null>();

  useEffect(() => {
    fetchChartData();
  }, []);

  const fetchChartData = async () => {
    try {
      const response = await apiClient.get('/analytics/actividades-por-financiador/');
      setChartData(response.data ? response.data : response);
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  };
  
  const options = {
    legend: {
      position: "bottom",
    },
    dataLabels: {
      dropShadow: {
        enabled: !1,
      },
    },
    colors: chartData?.colors,
    labels: chartData?.labels,
  };


  return (
    chartData ? (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={chartData.series}
        type="donut"
        height={270}
      />
    </React.Fragment>
    ):(<Spinner color="primary" />)
  );
};

export default Donut;
